<div class="center center-child">
    <div class="content-container">
        <div class="text">
            <img ngSrc="assets/images/error-404.svg" alt="error 404 svg file" class="error-img" height="268"
                 width="255" priority>
            <div class="text-container">
                <p class="text text-title">
                    Oops! Page Not Found
                </p>
                <p class="text text-description">
                    It looks like the page you’re looking for has vanished into thin air.
                </p>
            </div>
        </div>
        <div>
            <app-buttons [type]="'primary'" [size]="'xxl'" [routerLink]="'/home/candidate'">Back to Homepage</app-buttons>
        </div>
    </div>
</div>